import { EuroCircleOutlined, SaveOutlined } from '@ant-design/icons';
import { message, notification } from 'antd';
import axios from 'axios';
import _ from 'lodash';
import moment from 'moment';
import { useEffect, useRef, useState } from 'react';
import { connect } from 'react-redux';
import { useHistory } from 'react-router';
import { Dispatch } from 'redux';
import { Button, Card, CardContent, Form, Icon, Loader, Search, Table } from 'semantic-ui-react';
import { GetActiveSubcriptionDataAction, GetCustomerDataAction, ListPastSubscriptionsAction, StoreAction } from '../../../app/ActionsImpl';
import { ADMIN_API_HOST, COMPANY_LOOKUP_HOST, DATE_FORMAT } from '../../../constants';
import { translations } from '../../../utils/LocalizedStrings';
import { Modal } from 'semantic-ui-react';

export interface Props extends StateProps, DispatchProps { }

const SubscriptionPage = (props: Props) => {
    const [loading, setLoading] = useState(false);
    const [processing, setProcessing] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [searchString, setSearchString] = useState('');
    const [selectedCompany, setSelectedCompany] = useState<any>({});
    const [results, setResults] = useState([]);
    const [showPayButton, setShowPayButton] = useState(true)
    const [shouldReturn, setShouldReturn] = useState(true)
    const [open, setOpen] = useState(true);
    const promises = useRef<[]>([]);

    const history = useHistory();

    useEffect(() => {
        setFormData((old: any) => ({ ...old, name: props.user.attributes.given_name + " " + props.user.attributes.family_name, country: "Slovenská republika", personType: "ownerPerson", email: props.user.attributes.email }));
        props.getCustomerData()
        props.GetActiveSubscription()
        props.ListPastSubscription()
    }, []);

    useEffect(() => {
        if (props.activeSubscription?.active) {
            setShowPayButton(false)
        } else {
            setShowPayButton(true)
        }
    }, [props.activeSubscription])

    useEffect(() => {
        let urlParams: any = new URLSearchParams(window.location.search);
        const enablePolling = urlParams.get("enablepolling") === "true";
        const returnBack = urlParams.get("return") === "true";
        setShouldReturn(returnBack)

        urlParams.delete("editbilling");
        urlParams.delete("enablepolling");

        const newSearch = urlParams.toString();
        const currentSearch = window.location.search.replace(/^\?/, "");

        if (newSearch !== currentSearch && history) {
            history.push({
                pathname: window.location.pathname,
                search: newSearch ? `?${newSearch}` : "",
            });
        }
        if (enablePolling) {
            let interval: NodeJS.Timeout;
            setProcessing(true)
            const pollSubscription = async () => {


                let result = await axios
                    .get(ADMIN_API_HOST + "/stripe-customer/get-active")
                    .then((response) => response.data);
                if (result?.active) {
                    await props.GetActiveSubscription();
                    setProcessing(false);
                    clearInterval(interval);
                }
            };

            // Spustíme hneď, potom každých 5 sekúnd
            pollSubscription();
            interval = setInterval(pollSubscription, 5000);

            // Upratanie intervalu
            return () => clearInterval(interval);
        }
    }, []);

    useEffect(() => {
        if (props.customerData) {
            setFormData((old: any) => ({ name: old.name, email: old.email, ...props.customerData }));
            setSearchString(props.customerData.spolocnost)
        }
    }, [props.customerData]);


    const handleField = (e: any) => {
        if (e.persist) {
            e.persist();
        }
        setFormData((old: any) => ({ ...old, [e.target.name]: e.target.value }));
    };


    const [formData, setFormData] = useState<any>({});

    const personTypeOption = [
        { key: 'p', text: 'Fyzická osoba', value: 'ownerPerson' },
        { key: 'c', text: 'Podnikateľ, právnická osoba', value: 'ownerCompany' }
    ]

    const promiseCompanyLookup = (token: any, isCreateMode: any, type = '') => {
        const controller = new AbortController();
        const signal = controller.signal;
        let cPromise = new Promise((resolve, reject) => {
            fetch(
                `${COMPANY_LOOKUP_HOST}/company/lookup-by-name${isCreateMode ? '-available' : ''
                }`,
                {
                    body: JSON.stringify({ token, oddiel: type }),
                    method: 'post',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    signal,
                },
            )
                .then((res) => res.json())
                .then((res) => {
                    resolve(res.data);
                });
        });
        (cPromise as any).cancel = () => controller.abort();
        return cPromise;
    };

    const handleSearchChange = async (e: any, data: any, isCreateMode: any) => {
        // setResults([]);
        // setFreeCompanyName([]);
        setLoading(true);
        // setNewCompanyName(data.value);
        setSelectedCompany({});
        promises.current = promises.current || [];
        promises.current.forEach((p: any) => p.cancel());
        promises.current = [];
        const responseData: any = promiseCompanyLookup(data.value, isCreateMode, 'sro');
        (promises.current as any).push(responseData);
        responseData
            .then((responseData: any) => {
                if (responseData) {
                    setResults(
                        responseData.map((item: any) => ({
                            title: item.fullNames.filter((n: any) => moment(n.validFrom).isSameOrBefore(moment()) && !n.validTo)[0].value,
                            description: `IČO: ${item.identifiers.filter((i: any) => moment(i.validFrom).isSameOrBefore(moment()) && !i.validTo)[0].value}`,
                            full_data: item,
                        })),
                    );
                }
                setLoading(false);
            })
            .catch(() => {
                setLoading(false);
            });
    };

    const debounceHandleSearchChange = useRef(
        _.debounce(handleSearchChange, 500),
    );

    const onSearchChange = (e: any, data: any) => {
        setLoading(true);
        let newSearch = data.value;
        if (/^[0-9]+\s+$/.test(newSearch)) {
            newSearch = newSearch.replace(/\s/g, '');
        }

        setSearchString(newSearch);
        debounceHandleSearchChange.current(e, data, false);
    };

    useEffect(() => {
        if (selectedCompany && selectedCompany.fullNames && selectedCompany.identifiers) {
            setFormData((old: any) => ({ ...old, spolocnost: selectedCompany.fullNames.filter((n: any) => moment(n.validFrom).isSameOrBefore(moment()) && !n.validTo)[0].value }));
            setSearchString(selectedCompany.fullNames.filter((n: any) => moment(n.validFrom).isSameOrBefore(moment()) && !n.validTo)[0].value);
            setFormData((old: any) => ({ ...old, ico: selectedCompany.identifiers.filter((n: any) => moment(n.validFrom).isSameOrBefore(moment()) && !n.validTo)[0].value }));
            setFormData((old: any) => ({ ...old, legalForm: selectedCompany.legalForms.filter((n: any) => moment(n.validFrom).isSameOrBefore(moment()) && !n.validTo)[0].value }));
            setFormData((old: any) => ({ ...old, dic: selectedCompany.TIN?.DIC }));
            setFormData((old: any) => ({ ...old, icdph: selectedCompany.VAT?.IC_DPH }));
            if (selectedCompany && selectedCompany.addresses) {
                let address = selectedCompany.addresses.filter((n: any) => moment(n.validFrom).isSameOrBefore(moment()) && !n.validTo)[0]
                console.log(address)
                setFormData((old: any) => ({ ...old, line1: address.street + " " + address.buildingNumber, city: address.municipality.value, postal_code: address.postalCodes[0], country: address.country.value }));
            }
        }
    }, [selectedCompany])

    const handleSaveAndPay = async () => {
        try {
            await saveData()
            await props.getCustomerData()
            setLoading(true);
            let url = shouldReturn ? `/stripe-customer/subscribe?shouldReturn=true` : `/stripe-customer/subscribe`
            const response = await axios.get(
                ADMIN_API_HOST + url
            ).then(async (res) => {
                window.location.href = res.data.url
            });
            setLoading(false);
        } catch (e: any) {
            setLoading(false)
        }
    }

    const saveData = async () => {
        if (!validateFormData(formData)) {
            return; // nezapisuj, ak sú chyby
        }
        setIsLoading(true)
        try {
            let result = await axios.post(
                ADMIN_API_HOST + `/stripe-customer/post`,
                formData
            )
            if (result) {
                notification.success({ message: 'Údaje o užívateľovi boli uložené.' });
            }
            await props.getCustomerData()
            setIsLoading(false)
        } catch (e: any) {
            setIsLoading(false)
        }
    }


    // const handleSubscribe = async () => {
    //     if (!props.customerData) {
    //         message.warn("Prosím vyplňte fakturačné údaje")
    //         setShowPayButton(true)
    //     } else {
    //         setLoading(true);
    //         const response = await axios.get(
    //             ADMIN_API_HOST + `/stripe-customer/subscribe`
    //         ).then(async (res) => {
    //             window.location.href = res.data.url
    //         });

    //         setLoading(false);
    //     }
    // };

    const cancelSubscription = async () => {
        setIsLoading(true)
        try {
            let result = await axios.get(
                ADMIN_API_HOST + `/stripe-customer/cancel`,
                formData
            )
            if (result) {
                notification.success({ message: 'Automatická obnova predplatného bola zrušená' });
            }
            await props.GetActiveSubscription()
            setIsLoading(false)
        } catch (e: any) {
            setIsLoading(false)
        }
    };

    const reactivateSubscription = async () => {
        setIsLoading(true)
        try {
            let result = await axios.get(
                ADMIN_API_HOST + `/stripe-customer/reactivate`,
                formData
            )
            if (result) {
                notification.success({ message: 'Automatická obnova predplatného bola aktivovaná' });
            }
            await props.GetActiveSubscription()
            setIsLoading(false)
        } catch (e: any) {
            setIsLoading(false)
        }
    };

    const SubscriptionHistoryTable: React.FC<any> = ({ subscriptions }) => {
        if (!subscriptions || subscriptions.length === 0) {
            return <p><Icon name="history" /> Žiadne ukončené predplatné.</p>;
        }

        return (
            <Table celled striped>
                <Table.Header>
                    <Table.Row>
                        <Table.HeaderCell data-cell="Platné od">Platné od</Table.HeaderCell>
                        <Table.HeaderCell data-cell="Platné do">Platné do</Table.HeaderCell>
                        <Table.HeaderCell data-cell="Cena">Cena</Table.HeaderCell>
                        <Table.HeaderCell data-cell="Stav">Stav</Table.HeaderCell>
                    </Table.Row>
                </Table.Header>

                <Table.Body>
                    {subscriptions.map((sub: any) => {
                        const from = moment(sub.current_period_start * 1000).format(DATE_FORMAT);
                        const to = moment(sub.current_period_end * 1000).format(DATE_FORMAT);
                        const priceCents = sub.items.data[0]?.price?.unit_amount ?? 0;
                        const price = (priceCents / 100).toFixed(2);

                        return (
                            <Table.Row key={sub.id}>
                                <Table.Cell data-cell="Platné od">{from}</Table.Cell>
                                <Table.Cell data-cell="Platné do">{to}</Table.Cell>
                                <Table.Cell data-cell="Cena">{price} €</Table.Cell>
                                <Table.Cell data-cell="Stav">{(translations.subscriptionStatus as any)[sub.status]}</Table.Cell>
                            </Table.Row>
                        );
                    })}
                </Table.Body>
            </Table>
        );
    };

    const handleReturn = () => {
        if (window.opener) {
            window.opener.focus();
        }
        window.close();
    };

    const handleStay = () => {
        setOpen(false);
    };

    const validateFormData = (data: any): boolean => {
        const requiredFields = ["name", "email", "line1", "city", "postal_code", "country"];

        for (const field of requiredFields) {
            if (!data[field] || data[field].trim() === "") {
                message.warning(`Prosím, vyplňte všetky povinné polia`);
                return false;
            }
        }

        if (data.personType === "ownerCompany") {
            const companyFields = ["spolocnost", "ico"];
            for (const field of companyFields) {
                if (!data[field] || data[field].trim() === "") {
                    message.warning(`Prosím, vyplňte všetky povinné polia`);
                    return false;
                }
            }
        }

        return true;
    };


    return <>
        {isLoading ? (
            <Loader active inline="centered" size="large">
                Načítava sa...
            </Loader>
        ) : (<>
            <>
                {props.activeSubscription?.active && shouldReturn &&
                    <Modal open={open} size="small" dimmer="blurring" className='subscription-finish-modal'>
                        <Modal.Header>Predplatné dokončené</Modal.Header>
                        <Modal.Content>
                            <p>Pre dokončenie zmluvy sa vráťte do predchádzajúceho okna:</p>
                        </Modal.Content>
                        <Modal.Actions>
                            <Button className='cancel-subscription-button' onClick={handleStay}>
                                Zostať tu
                            </Button>
                            <Button color="green" onClick={handleReturn}>
                                Návrat k zmluve
                            </Button>
                        </Modal.Actions>
                    </Modal>
                }
                {processing ?
                    <Card className="orderCard subscription-card" color={props.activeSubscription?.subscription?.cancel_at_period_end ? "orange" : "green"}>
                        <Card.Content>
                            <Card.Header>Aktívne predplatné</Card.Header>
                            <Loader active inline="centered" content="Spracováva sa..." />
                        </Card.Content>
                    </Card>
                    :
                    (props.activeSubscription?.active ?
                        <Card className="active-subscription-card" color={props.activeSubscription?.subscription?.cancel_at_period_end ? "orange" : "green"}>
                            <Card.Content>
                                <Card.Header>Aktívne predplatné</Card.Header>
                                <Card.Meta>Platnosť: {moment(props.activeSubscription?.subscription?.current_period_start * 1000).format(DATE_FORMAT)} – {moment(props.activeSubscription?.subscription?.current_period_end * 1000).format(DATE_FORMAT)}</Card.Meta>
                                <Card.Description>
                                    <p><strong>Cena:</strong> {(props.activeSubscription?.subscription?.items?.data[0].price?.unit_amount / 100).toFixed(2)} € / mesiac</p>
                                    {props.activeSubscription?.subscription?.cancel_at_period_end ? (
                                        <p><Icon name="warning circle" color="orange" /> Obnova zrušená, platí do {moment(props.activeSubscription?.subscription?.current_period_end * 1000).format(DATE_FORMAT)}</p>
                                    ) : (
                                        <p><strong>Ďalšia fakturácia:</strong> {moment(props.activeSubscription?.subscription?.current_period_end * 1000).format(DATE_FORMAT)}</p>
                                    )}
                                </Card.Description>
                            </Card.Content>
                            <Card.Content extra>
                                {props.activeSubscription?.subscription?.status === "active" && (
                                    props.activeSubscription?.subscription?.cancel_at_period_end ? (
                                        <Button color="green" onClick={reactivateSubscription} fluid>
                                            Obnoviť predplatné
                                        </Button>
                                    ) : (
                                        <Button className='cancel-subscription-button' onClick={cancelSubscription} fluid>
                                            Zrušiť obnovu predplatného
                                        </Button>
                                    )
                                )}
                            </Card.Content>
                        </Card>
                        :
                        <div id="cennik" className="contracts-subscription">
                            <Card className='firstCard'>
                                <Card.Content>
                                    <Card.Header>
                                        <h5>Všetky zmluvy</h5>
                                        <p>pre začínajúcich podnikateľov</p>
                                    </Card.Header>
                                    <Card.Description>
                                        <div className='price-container'>
                                            <div className="pricingTablePrice">18,99 €</div>
                                            <div className="pricingDescription">(23,36 € s DPH)</div>
                                            <div className="pricingDescription">mesačne</div>
                                        </div>
                                        <div className='contracts-benefits'>
                                            <div className="pricingDescription"><Icon name='check circle' /> <span><b>Elektronické podpisovanie</b> KEP-om aj iba elektronickým podpisom</span></div>
                                            <div className="pricingDescription"><Icon name='check circle' /> <span><b>Neobmedzený prístup</b> k tvorbe zmlúv</span></div>
                                            <div className="pricingDescription"><Icon name='check circle' /> <span>Vždy aktuálne údaje z registra podnikateľov(RPO)</span></div>
                                            <div className="pricingDescription"><Icon name='check circle' /> <span>Okamžité generovanie a úpravy dokumentov</span></div>
                                            <div className="pricingDescription"><Icon name='check circle' /><span>Bezpečné uloženie a <b>archiváciu zmlúv</b></span></div>
                                            <div className="pricingDescription"><Icon name='check circle' /><span>Právne aktuálne vzory <b>pripravené odborníkmi</b></span></div>
                                        </div>
                                        <div className='redirectPrice'>
                                            <Button onClick={handleSaveAndPay} disabled={loading}>{loading ? "Spracováva sa..." : "Predplatiť si"}</Button>
                                        </div>
                                    </Card.Description>
                                </Card.Content>
                            </Card>
                            {/* <Card className='secondCard'>
                                <Card.Content>
                                    <Card.Header>
                                        <h5>Pripravujeme</h5>
                                        <p>pre menších a stredných podnikateľov</p>
                                    </Card.Header>
                                    <Card.Description>
                                        <div className='price-container'>
                                            <div className="pricingTablePrice">29,99 €</div>
                                            <div className="pricingDescription">(36,89 € s DPH)</div>
                                            <div className="pricingDescription">mesačne</div>
                                        </div>
                                        <div className='contracts-benefits'>
                                            <div className="pricingDescription"><Icon name='check circle' /> <span>20 dokumentov mesačne zadarmo</span></div>
                                            <div className="pricingDescription"><Icon name='check circle' /> <span>Prednastavenie dokumentov</span></div>
                                            <div className="pricingDescription"><Icon name='check circle' /> <span>Nastavenie vlastného vzhľadu dokumentov</span></div>
                                            <div className="pricingDescription"><Icon name='check circle' /> <span>História zmien dokumentov</span></div>
                                            <div className="pricingDescription"><Icon name='check circle' /> <span>Tvorba dvojjazyčných dokumentov</span></div>
                                        </div>
                                        <div className='redirectPrice'>
                                            <Button>Vybrať</Button>
                                        </div>
                                    </Card.Description>
                                </Card.Content>
                            </Card> */}
                        </div>
                    )
                }
            </>
            {processing ?
                <Card className="orderCard subscription-card"  color={props.activeSubscription?.subscription?.cancel_at_period_end ? "orange" : "green"}>
                    <Card.Content>
                        <Card.Header>Aktívne predplatné</Card.Header>
                        <Loader active inline="centered" content="Spracováva sa..." />
                    </Card.Content>
                </Card>
                :
                <>
                    <Card className="orderCard subscription-card">
                        <CardContent>
                            <Form className="orderUiForm">
                                <Form.Field>
                                    <>
                                        <h3>Vyplňte svoje údaje</h3>
                                        <span className='searchCompanyNameLabel'>Typ osoby</span>
                                        <Form.Select className='customDropdown' value={formData.personType} options={personTypeOption} onChange={(e, { value }) => {
                                            const formDataCopy = JSON.parse(JSON.stringify(formData))
                                            formDataCopy.personType = value
                                            setFormData(formDataCopy)
                                        }}>
                                        </Form.Select>
                                    </>
                                </Form.Field>
                                <Form.Field className="subscription-form">
                                    <Form.Input
                                        label="Meno a priezvisko"
                                        name="name"
                                        value={formData.name}
                                        onChange={handleField}
                                        required
                                    />
                                    {formData.personType === "ownerCompany" &&
                                        <div>
                                            <span className='searchCompanyNameLabel'>Názov spoločnosti</span>
                                            <Search
                                                loading={loading}
                                                onResultSelect={(e, data) => {
                                                    setSelectedCompany(data.result.full_data);
                                                }}
                                                name="spolocnost"
                                                onSearchChange={onSearchChange}
                                                results={loading ? [] : results}
                                                placeholder={formData.spolocnost}
                                                value={searchString}
                                                size={'big'}
                                                required
                                            />
                                        </div>
                                    }
                                    <Form.Input
                                        label={translations.artifacts.CheckouFormBox.street}
                                        name="line1"
                                        value={formData.line1}
                                        onChange={handleField}
                                        required
                                    />
                                    <Form.Input
                                        label={translations.artifacts.CheckouFormBox.city}
                                        name="city"
                                        value={formData.city}
                                        onChange={handleField}
                                        required
                                    />
                                    <Form.Input
                                        label={translations.artifacts.CheckouFormBox.zip}
                                        name="postal_code"
                                        value={formData.postal_code}
                                        onChange={handleField}
                                        required
                                    />
                                    <Form.Input
                                        disabled
                                        label={translations.artifacts.CheckouFormBox.country}
                                        name="country"
                                        value={formData.country}
                                        onChange={handleField}
                                        required
                                    />
                                    {formData.personType === "ownerCompany" && <>
                                        <Form.Input
                                            label="IČO"
                                            name="ico"
                                            value={formData.ico}
                                            onChange={handleField}
                                            required
                                        />
                                        <Form.Input
                                            label={translations.artifacts.CheckouFormBox.dic}
                                            name="dic"
                                            value={formData.dic}
                                            onChange={handleField}
                                        />
                                        <Form.Input
                                            label={translations.artifacts.CheckouFormBox.icdph}
                                            name="icdph"
                                            value={formData.icdph}
                                            onChange={handleField}
                                        />
                                    </>
                                    }
                                </Form.Field>
                                <Form.Field className='subscription-buttons-container'>
                                    <Button className='subscription-save-button' onClick={saveData}><SaveOutlined /> Uložiť</Button>
                                    {showPayButton &&
                                        <Button className='subscription-button' onClick={handleSaveAndPay}><EuroCircleOutlined /> Predplatiť</Button>
                                    }
                                </Form.Field>
                            </Form>
                        </CardContent>
                    </Card>

                    {props.inactiveSubscriptions?.history && props.inactiveSubscriptions?.history.length > 0 &&
                        <Card className="subscription-history-table">
                            <CardContent>
                                <h3>História predplatného</h3>
                                <SubscriptionHistoryTable subscriptions={props.inactiveSubscriptions?.history} />
                            </CardContent>
                        </Card>
                    }
                </>
            }
        </>
        )}
    </>
};

const mapStateToProps = ({ appState }: any) => ({
    user: appState.cognitoUser,
    customerData: appState.customerData,
    activeSubscription: appState.activeSubscription,
    inactiveSubscriptions: appState.inactiveSubscriptions
});

interface DispatchProps {
    GetActiveSubscription: () => void,
    ListPastSubscription: () => void,
    getCustomerData: () => void;

}

function mapDispatchToProps(dispatch: Dispatch<StoreAction, any>): DispatchProps {
    return {
        GetActiveSubscription: () => dispatch(GetActiveSubcriptionDataAction()),
        ListPastSubscription: () => dispatch(ListPastSubscriptionsAction()),
        getCustomerData: () => dispatch(GetCustomerDataAction()),
    }
};

type StateProps = ReturnType<typeof mapStateToProps>;

export default connect(mapStateToProps, mapDispatchToProps)(SubscriptionPage)
